import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ConfirmRegisterPageRoutingModule } from "./confirm-register-routing.module";

import { ConfirmRegisterPage } from "./confirm-register.page";
import { TranslateModule } from "@ngx-translate/core";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ConfirmRegisterPageRoutingModule,
    TranslateModule,
    LoadingStiModule,
  ],
  declarations: [ConfirmRegisterPage],
})
export class ConfirmRegisterPageModule {}
